import React, { Component } from 'react'
import { Switch, Route, Redirect, withRouter } from 'react-router-dom'
import { RouteComponentProps } from 'react-router'
import Application from '../../components/Template/Application'
import { AuthProvider, AuthConsumer } from '../../context/AuthContext'
import { ThemeProvider } from '../../context/ThemeContext'
import NavRoutes from '../../navigation'

// Define component type
type AppType = RouteComponentProps

class App extends Component<AppType> {
  render() {
    return (
      <AuthProvider>
        <ThemeProvider>
          <Switch>
            {
              NavRoutes.filter(p => !p.isPrivate).map((route, index) => {
                const { path, exact, component } = route

                return <Route key={`route-${index}`} path={path} exact={exact} component={component} />
              })
            }

            <AuthConsumer>
              {({ adminUser, loggedIn, requestSessionInfo, requestSessionUnRegister }) => {
                if (loggedIn && adminUser) return <Application {...this.props} user={adminUser} getSessionInfo={requestSessionInfo} signOut={requestSessionUnRegister} />

                return <Redirect from='/' to='/login' exact />
              }}
            </AuthConsumer>
          </Switch>
        </ThemeProvider>
      </AuthProvider>
    )
  }
}

export default withRouter(App)
